module.exports = __webpack_public_path__ + "img/V83.21cd8b7d.jpg";